import styled from "styled-components";

import { type CustomPhoneInputProps } from "@/components/ui/PhoneInput/CustomPhoneInput";

const StyledCustomPhoneInput = styled.div<CustomPhoneInputProps>`
  display: block;
  position: relative;
  margin-bottom: ${({ $marginbottom }) => $marginbottom};
  width: 100%;
  z-index: 1;

  [data-disabled="true"] {
    background-color: var(--disabledInput, #f5f5f5) !important;
    border: 1px solid var(--disabledInput, #f5f5f5) !important;
    color: var(--neutral400, #b3b3b3) !important;
    pointer-events: none;
  }

  .mainWrapper {
    display: flex;
    flex-direction: column;
    // gap: 1.5rem;
    // flex-wrap: nowrap;
    // width: 100%;
    position: relative;

    label {
      font-size: 14px;
      font-family: Inter, Arial, sans-serif;
      color: var(--inputLabelColor, #000);
      text-align: left;
      display: flex;
      align-items: center;
      line-height: 1;
      gap: 0.125rem;
      margin-bottom: 0.5rem;
      position: relative;
      white-space: nowrap;

      ${({ required }) =>
        required
          ? `
      &::after {
        content: '*';
        color: red;
      }
      `
          : ""}
    }

    .subWrapperGroup {
      display: flex;
      width: 100%;
      gap: 0.625rem;
      flex-wrap: nowrap;

      .subWrapper {
        width: fit-content;
      }

      .subWrapper:nth-of-type(1) {
        min-width: 6rem;
      }

      .subWrapper:nth-of-type(2) {
        flex-grow: 1;
      }
    }
  }

  .inputWrapper {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    // width: 100%;
    border: ${({ $border }) => `1px solid ${$border ?? "#D1D5DB"}`};
    border-radius: ${({ $borderRadius }) => $borderRadius};
    padding: 0 1rem;
    height: ${({ height }) => height};
    background-color: ${({ $bgColor }) => $bgColor ?? "white"};

    &:focus-within {
      border: 1px solid var(--primary, #344563);
    }

    &:hover {
      // border: 1px solid var(--neutral600, gray);
    }
  }

  .selectWrapper {
    position: relative;
    display: flex;
    gap: 0.25rem;
    align-items: center;
    width: 100%;

    .select-container {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      width: inherit;
      cursor: pointer;

      span {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
      }
    }

    input {
      width: fit-content;
    }

    .dialCode {
      display: flex;
      align-items: center;
      width: 100%;
      cursor: pointer;
      justify-content: space-evenly;
      color: var(--dark, #000);
    }

    border: ${({ $border }) => `1px solid ${$border ?? "#D1D5DB"} `};
    border-radius: ${({ $borderRadius }) => $borderRadius};
    padding: 0 0.5rem;
    height: ${({ height }) => height};
    background-color: ${({ $bgColor }) => $bgColor ?? "white"};
    transition: 0.3s;

    &:focus-within {
      border: 1px solid var(--primary, #344563);
    }

    select {
      width: 100%;
      border: none;
      transition: 0.3s;
      display: inline-flex;
      align-items: center;

      &:focus {
        outline: none;
      }
    }

    select:disabled {
      background-color: var(--disabledInput, #f5f5f5);
      color: var(--neutral400, #b3b3b3);
      cursor: not-allowed;
    }
  }

  .selectWrapper[data-disabled="true"] {
    background-color: var(--disabledInput, #f5f5f5) !important;
    border: 1px solid var(--disabledInput, #f5f5f5) !important;
    color: var(--neutral400, #b3b3b3) !important;
    pointer-events: none;
  }

  .prefixIcon,
  .suffixIcon {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 1.125rem !important;
      object-fit: cover;
    }
    svg {
      width: 1.125rem !important;
      height: auto !important;
      font-size: 1.125rem !important;
    }
  }

  .input-container {
    position: relative;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    color: var(--dark, #000);
    border: none;
    width: 100%;
    transition: 0.3s;
    background: transparent;
    align-items: center;

    input {
      width: 100%;
      box-sizing: border-box;
      border: none;
      color: var(--dark, #000);
      transition: 0.3s;
      background-color: transparent;
      font-size: 1rem;
      display: inline-flex;
      align-items: center;

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: #ffffff82 !important;
      }
    }

    input:disabled {
      background-color: var(transparent, --disabledInput, #f5f5f5);
      color: var(--neutral400, #b3b3b3);
      cursor: not-allowed;
    }
  }

  .error {
    font-size: 12px;
    color: var(--error, #eb5757);
    position: absolute;
    left: 0;
    text-align: left;
    padding: 0.25rem 0px 0px 0px;
    margin: 0px;
    line-height: 1;
  }
  .eye-icon {
    cursor: pointer;
  }
  position: relative;
`;

export default StyledCustomPhoneInput;
